import { render, staticRenderFns } from "./DaftarTes.vue?vue&type=template&id=484a2276&scoped=true"
import script from "./DaftarTes.vue?vue&type=script&lang=js"
export * from "./DaftarTes.vue?vue&type=script&lang=js"
import style0 from "./DaftarTes.vue?vue&type=style&index=0&id=484a2276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a2276",
  null
  
)

export default component.exports